BatchGeoStore.addReducer(
  "AdminSubscription",
  {
    plan: "",
    planValue: 0,
    currentAddons: 0,
    addonsToUpdate: 1,
    addonValue: 0,
  },
  {
    ADMIN_SUBSCRIPTION_HYDRATE: (state, action) => {
      return Object.assign({}, state, {
        plan: action.plan,
        planValue: action.planValue,
        currentAddons: action.currentAddons,
        addonsToUpdate: 1,
        addonValue: action.addonValue,
      });
    },
    ADMIN_SUBSCRIPTION_INCREMENT_ADDONS_TO_UPDATE: (state, _action) => {
      return Object.assign({}, state, {
        addonsToUpdate: state.addonsToUpdate + 1,
      });
    },
    ADMIN_SUBSCRIPTION_DECREMENT_ADDONS_TO_UPDATE: (state, _action) => {
      return Object.assign({}, state, {
        addonsToUpdate:
          state.addonsToUpdate === 1
            ? state.addonsToUpdate
            : state.addonsToUpdate - 1,
      });
    },
    ADMIN_SUBSCRIPTION_RESET_ADDONS_TO_UPDATE: (state, _action) => {
      return Object.assign({}, state, {
        addonsToUpdate: 1,
      });
    },
  },
);
